<template>
    <div class="card">
        <div class="bg-blue-light p-1 mb-2">
            <TitleButton 
                :showBtn="true"
                :showAddNew="false"
                :title="`Cell Counter Machine`"
            />
        </div>
        <div class="px-2">
          <DateQuerySetter
              :key="$route.query.start + '-' + $route.query.end"
              btnTitle="Refresh"
              @onClickGo="onClickToGo"
              class="tds-vds-query-setter"
          >
          </DateQuerySetter>
        </div>
        <div class="col-12 px-2 mt-2">

          <div class="card investigation-card">
            <div class="table-responsive">
              <table class="table custom-table-padding">
                <thead>
                <tr>
                  <th>Sample ID</th>
                  <th>Bill No</th>
                  <th>Patient Name</th>
                  <th>Report name</th>
                  <th>Service Names</th>
                  <th>Sample Status</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in cellCounterData" :key="i">
                  <td>{{ item.sample_id }} </td>
                  <td>{{ item.bill_number }}</td>
                  <td>{{ item.contact_profile_name }} {{ item.serial_no ? '(' + item.serial_no + ')' : '' }}</td>
                  <td>{{ item.report_names }}</td>
                  <td>{{ item.product_names }}</td>
                  <td>{{ convertToTitleCase(item.investigation_sample_status) }}</td>
                  <td>{{ convertToTitleCase(item.investigation_sample_status) }}</td>
                  <td>
                    <button @click="onClickToEdit(item)" class="btn btn-primary btn-sm edit-btn">
                      <i class="fas fa-pen"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>

              <p v-if="!cellCounterData.length" class="text-center mt-5">No data</p>
            </div>
          </div>

            <div class="px-2 bottom-0 mt-2">
                <Pagination
                    :offset="offset"
                    @onPageChange="onPageChange"
                    ref="pagination"
                />
            </div>

        </div>

        <Loader v-if="loading"/>
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton.vue';
import Pagination from '@/components/atom/Pagination'
import {useRoute, useRouter} from "vue-router";
import handleContact from "@/services/modules/contact";
import {computed, inject, onMounted, ref} from "vue";
import Loader from "@/components/atom/LoaderComponent.vue";
import {useStore} from "vuex";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import handleHospital from '@/services/modules/hospital'
import { convertToTitleCase } from '@/services/utils/global';
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';

const $route = useRoute();
    const $router = useRouter();
    const $store = useStore();
    const params = ref({
      offset: 20,
    });
    const showError = inject('showError');
    const showSuccess = inject('showSuccess');
    const { getCellCounterMachineData } = handleHospital();
    const { fetchContactProfiles } = handleContact();
    const { formatPatientLabel } = useAsyncDropdownHelper()

    const offset = ref(200);
    const loading = ref(false);
    const cellCounterData = ref([])
    const status = ref(null)

    const start = computed(() => $route.query.start);
    const end = computed(() => $route.query.end);
    const page = computed(() => $route.query.page);
    const companyId = computed(() => $route.params.companyId);

    const setPaginationData = (data) => {
        $store.commit('setPaginationData', data)
    };

    const onClickToEdit = (investigationGeneral) => {
      const query = Object.assign({}, $route.query);
      const params = Object.assign({}, $route.params)
      query.machine_data_id = investigationGeneral.id

      $router.push({
        name: 'cell-counter-investigation-general',
        params: params,
        query: {
          ...query,
        }
      })
    }

    const onPageChange = async (page) => {
        let routeQuery = Object.assign({}, $route.query)
        routeQuery.page = page
        await $router.push({path: $route.path, query: routeQuery})
        await getSalesList()
    }

    const setPagination = (data) => {
        setPaginationData({
          records: data.total,
          perPage: data.per_page,
          currentPage: data.current_page,
        })
    }

    const onClickGo = async () => {
        await getSalesList();
    }

    const getQuery = () => {
      let query = `?company_id=${$route.params.companyId}&machine_type=cell_counter_machine`;
      if ($route.query.page) query += '&page=' + $route.query.page;
      if ($route.query.start) query += '&start_date=' + $route.query.start;
      if ($route.query.end) query += '&end_date=' + $route.query.end;
      query += '&offset=' + params.value.offset
      return query;
    };

  const onClickToGo = () => {
    getSalesList()
  }

    async function getSalesList() {
      loading.value = true;
      cellCounterData.value = []
      try {
        const res = await getCellCounterMachineData(getQuery());
        if (!res.status) {
          return $store.commit("resetPagination")
        }
        cellCounterData.value = res.data.data;
        if (cellCounterData.value.length > 0) {
          setPagination(res.data)
        }
      } catch (err) {
        if (err.response) {
          showError(err.response.message)
        }
      } finally {
        loading.value = false;
      }
    }

    onMounted( async () => {
      const today = new Date().toISOString().split('T')[0]

      await $router.replace({
        query: {
          ...$route.query,
          start: today,
          end: today
        }
      })
      await Promise.all([
          getSalesList()
      ])
    })
</script>